<ng-container>
  <div class="p-field" [ngClass]="options.containerClass">
    <label class="mb-2">{{ options.label }}</label>
    <p-editor
      [formControlName]="options.formControlName"
      [style]="{ height: '320px' }"
    ></p-editor>
    <!-- <editor
      #mojeditor
      [formControlName]="options.formControlName"
      apiKey="ip68ly5t3uvkqblztxxhodgg9b3u9gx7v0k6h5yi75a7tsgs"
      [init]="editorOptions"
    ></editor>-->
  </div>
</ng-container>
